import React, { useState, useEffect } from 'react'
import Footer from '../../footer'
import StudentHeader from '../header'
import StudentSideBar from '../sidebar'
import { getIdData } from '../../../lib/taskmanageview'
import { updateData } from '../../../lib/taskm'
import { useNavigate, useParams } from 'react-router-dom'

export default function StudentTaskManageDetail() {
  const [taskDetailInfo, setTaskDetailInfo] = useState()
  const [answer, setAnswer] = useState()
  const navigate = useNavigate()
  let { slug } = useParams()

  async function GetData() {
    const info = await getIdData(slug)
    setTaskDetailInfo(info)
    console.log('info', info)
  }

  useEffect(() => {
    GetData()
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()

    //est time
    const time = new Date().toLocaleString('en-US', {
      timeZone: 'America/New_York'
    })

    //console.log("Date",time);
    await updateData({
      id: slug,
      answer: answer,
      close_date: time,
      status: false
    })

    navigate('/student/student-tasklist')
  }

  return (
    <div className='col-12'>
      <div className='tak-instruct-group'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='settings-widget'>
              <div className='settings-inner-blk p-0'>
                <div className='sell-course-head comman-space'>
                  <h3>Task Detail</h3>
                  <p>
                    Order Dashboard is a quick overview of all current orders.
                  </p>
                </div>
              </div>
            </div>
            <div className='settings-widget'>
              <div className='settings-inner-blk p-0'>
                <div className='checkout-form personal-address add-course-info'>
                  <div className='personal-info-head'>
                    <h4>Task Details</h4>
                    <p className='mb-5'> </p>
                  </div>
                  <form role='form' onSubmit={handleSubmit}>
                    <div className='row'>
                      <div className='col-lg-6'>
                        <div className='form-group'>
                          <label className='form-control-label'>
                            Instructor First Name
                          </label>
                          <p>
                            {taskDetailInfo
                              ? taskDetailInfo[0].instructorname
                              : ''}
                          </p>
                        </div>
                      </div>
                      <div className='col-lg-6'>
                        <div className='form-group'>
                          <label className='form-control-label'>
                            Instructor SurName
                          </label>
                          <p>
                            {taskDetailInfo
                              ? taskDetailInfo[0].instructorsurname
                              : ''}
                          </p>
                        </div>
                      </div>
                      <div className='col-lg-6'>
                        <div className='form-group'>
                          <label className='form-control-label'>Topic</label>
                          <p>
                            {taskDetailInfo ? taskDetailInfo[0].subject : ''}
                          </p>
                        </div>
                      </div>
                      <div className='col-lg-6'>
                        <div className='form-group'>
                          <label className='form-control-label'>Status</label>
                          <p>
                            {taskDetailInfo ? (
                              taskDetailInfo[0].status ? (
                                <span className='badge info-low'>Opened</span>
                              ) : (
                                <span className='badge info-high'>Closed</span>
                              )
                            ) : (
                              ''
                            )}
                          </p>
                        </div>
                      </div>
                      <div className='col-lg-12'>
                        <div className='form-group'>
                          <label className='form-control-label'>Desc</label>
                          <p>{taskDetailInfo ? taskDetailInfo[0].desc : ''}</p>
                        </div>
                      </div>
                      <div className='col-lg-12'>
                        <div className='form-group'>
                          <label className='form-control-label'>Answer</label>
                          <textarea
                            rows='4'
                            onChange={(e) => setAnswer(e.target.value)}
                            className='form-control'
                            placeholder='Your Answer'
                          ></textarea>
                        </div>
                      </div>
                      <div className='update-profile'>
                        <button type='submit' className='btn btn-primary'>
                          Update Task
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
